const advertisementGuide = {

advertisementGuide: {
  meta: {
    title: "Werbeanleitung",
    subtitle: "Erstelle Kampagnen, erreiche die richtige Zielgruppe, verwalte Budgets und halte die Richtlinien ein.",
    back: "Zurück",
    overviewTitle: "Werbeanleitung",
    searchPlaceholder: "Werbeanleitung durchsuchen",
  },

  sidebar: {
    adGuide: "Werbeanleitung",
    campaignCreation: "Kampagnenerstellung",
    targetingDelivery: "Targeting & Auslieferung",
    reviewModeration: "Prüfung & Moderation",
    performanceBilling: "Leistung & Abrechnung",
    bestPractices: "Best Practices",
    compliance: "Sicherheit & Richtlinien",
    troubleshooting: "Problembehebung",
  },

  overview: {
    advertisingOverview: "Überblick über Werbung",
    whoCanAdvertise: "Wer kann Werbung schalten?",
    beforeYouStart: "Bevor du beginnst",

    createCampaign: "Kampagne erstellen",
    campaignUrl: "Kampagnen-URL",
    buttonText: "Button-Text",
    uploadAdMedia: "Werbemedien hochladen",
    campaignDetails: "Kampagnendetails",
    launchCampaign: "Kampagne starten",

    targetLocation: "Zielstandort",
    deliveryModes: "Auslieferungsmodi",
    budgetSetup: "Budget festlegen",
    campaignFrequency: "Kampagnenhäufigkeit",

    adReview: "Anzeigenprüfung",
    pendingApproval: "Ausstehende Freigabe",
    rejectionReasons: "Gründe für eine Ablehnung",
    editRejectedAd: "Abgelehnte Anzeige bearbeiten",

    pricingCpm: "Preise und CPM",
    spendCounting: "Wann Kosten berechnet werden",
    campaignStats: "Kampagnenstatistiken",
    billingInvoices: "Abrechnung und Rechnungen",

    creativeBestPractices: "Best Practices für Werbemittel",
    landingPageQuality: "Qualität der Zielseite",
    avoidAdFatigue: "Anzeigenmüdigkeit vermeiden",

    prohibitedContent: "Verbotene Inhalte",
    responsibleAdvertising: "Verantwortungsvolle Werbung",
    copyrightAndMediaRights: "Urheber- und Medienrechte",

    invalidUrl: "Ungültige URL",
    unsupportedMedia: "Nicht unterstützte Medien",
    campaignNotDelivering: "Kampagne wird nicht ausgeliefert",
    contactAdsSupport: "Werbesupport kontaktieren",
  },

  sections: {
    advertisingOverview: {
      title: "Überblick über Werbung",
      body: [
        {
          type: "paragraph",
          text: "Mit Werbung kannst du bezahlte Kampagnen erstellen, die als gesponserte Inhalte auf der Plattform angezeigt werden.",
        },
        {
          type: "bullets",
          items: [
            "Erstelle Werbekampagnen mit Medien, URL, Button-Text, Targeting und Budget.",
            "Kampagnen werden überprüft, bevor sie ausgeliefert werden.",
            "Die Leistung hängt von der Qualität der Werbemittel, dem Targeting, dem Budget und den Auslieferungseinstellungen ab.",
          ],
        },
      ],
    },

    createCampaign: {
      title: "Kampagne erstellen",
      body: [
        {
          type: "paragraph",
          text: "Um eine Werbeanzeige zu erstellen, starte eine neue Kampagne und vervollständige die erforderlichen Kampagneneinstellungen.",
        },
        {
          type: "steps",
          items: [
            "Öffne den Bereich „Werbung“.",
            "Klicke auf „+ Neue Kampagne erstellen“.",
            "Füge eine gültige Kampagnen-URL hinzu.",
            "Wähle den Button-Text für deine Anzeige.",
            "Lade deine Werbemedien hoch.",
            "Klicke auf „Weiter“.",
            "Füge Kampagnendetails wie Name, Zielstandort, Budget und Auslieferungshäufigkeit hinzu.",
            "Klicke auf „Kampagne starten & hochladen“.",
          ],
        },
        {
          type: "note",
          text: "Nach dem Start wird deine Anzeige geprüft, bevor sie ausgeliefert wird.",
        },
      ],
    },

    campaignUrl: {
      title: "Kampagnen-URL",
      body: [
        {
          type: "paragraph",
          text: "Die Kampagnen-URL ist die Zielseite, die Nutzer besuchen, wenn sie auf den Button deiner Werbeanzeige klicken.",
        },
        {
          type: "bullets",
          items: [
            "Verwende eine gültige URL, die mit https:// beginnt.",
            "Stelle sicher, dass die Seite korrekt geladen wird.",
            "Die Zielseite sollte dem Inhalt und Versprechen deiner Anzeige entsprechen.",
            "Vermeide defekte Links, irreführende Weiterleitungen oder themenfremde Seiten.",
          ],
        },
      ],
    },

    uploadAdMedia: {
      title: "Werbemedien hochladen",
      body: [
        {
          type: "paragraph",
          text: "Deine Werbemedien sind die visuellen Inhalte, die Nutzer im Feed sehen.",
        },
        {
          type: "bullets",
          items: [
            "Verwende klare und hochwertige Bilder oder Videos.",
            "Vermeide zu kleinen oder schwer lesbaren Text.",
            "Nutze ausschließlich Medien, an denen du die erforderlichen Rechte besitzt oder für deren Nutzung du eine Erlaubnis hast.",
            "Stelle sicher, dass deine Medien den Werberichtlinien und Plattformregeln entsprechen.",
          ],
        },
      ],
    },

targetLocation: {
  title: "Zielstandort",
  body: [
    {
      type: "paragraph",
      text: "Mit dem Standort-Targeting legst du fest, in welchen Regionen deine Werbeanzeige angezeigt werden soll.",
    },
    {
      type: "bullets",
      items: [
        "Wähle „Weltweit“, wenn deine Kampagne ein breites Publikum erreichen soll.",
        "Wähle Länder-, Kontinent- oder Städte-Targeting für gezieltere Kampagnen.",
        "Nutze Städte-Targeting für lokale Unternehmen oder Veranstaltungen.",
        "Vermeide eine zu enge Zielgruppenauswahl, wenn du eine größere Reichweite erzielen möchtest.",
      ],
    },
  ],
},

deliveryModes: {
  title: "Auslieferungsmodi",
  body: [
    {
      type: "paragraph",
      text: "Die Auslieferungsmodi bestimmen, wie schnell das Budget deiner Kampagne verwendet wird.",
    },
    {
      type: "bullets",
      items: [
        "Leichte Auslieferung verbraucht das Budget langsamer.",
        "Ausgewogene Auslieferung sorgt für eine gleichmäßige Verteilung der Kampagne.",
        "Häufige Auslieferung verwendet das Budget schneller und erreicht Nutzer intensiver.",
        "Verwende „Häufig“, wenn deine Kampagne nur für einen begrenzten Zeitraum laufen soll oder zeitkritische Angebote bewirbt.",
      ],
    },
  ],
},

budgetSetup: {
  title: "Budget festlegen",
  body: [
    {
      type: "paragraph",
      text: "Mit dem Budget bestimmst du, wie viel deine Kampagne maximal ausgeben darf.",
    },
    {
      type: "bullets",
      items: [
        "Beginne beim Testen einer neuen Kampagne mit einem moderaten Budget.",
        "Erhöhe das Budget schrittweise, nachdem du die Kampagnenleistung ausgewertet hast.",
        "Die Auslieferung der Kampagne kann je nach Zielgruppe und Nachfrage schwanken.",
      ],
    },
  ],
},

adReview: {
  title: "Anzeigenprüfung",
  body: [
    {
      type: "paragraph",
      text: "Werbeanzeigen werden geprüft, bevor sie ausgeliefert werden können.",
    },
    {
      type: "bullets",
      items: [
        "Die Prüfung kann automatisiert oder manuell erfolgen.",
        "Wenn du eine Anzeige während der Prüfung bearbeitest, kann der Prüfprozess erneut beginnen.",
        "Genehmigte Anzeigen werden ausgeliefert, sobald die Kampagneneinstellungen aktiv sind.",
        "Abgelehnte Anzeigen müssen korrigiert werden, bevor sie veröffentlicht werden können.",
      ],
    },
  ],
},

prohibitedContent: {
  title: "Verbotene Inhalte",
  body: [
    {
      type: "paragraph",
      text: "Werbeanzeigen dürfen keine Inhalte enthalten, die gegen unsere Plattformregeln, geltendes Recht oder Sicherheitsstandards verstoßen.",
    },
    {
      type: "bullets",
      items: [
        "Verwende keine irreführenden Aussagen oder betrügerischen Angebote.",
        "Bewirb keine Belästigung, Hass, Gewalt, Betrug oder illegale Aktivitäten.",
        "Nutze keine urheberrechtlich geschützten Medien, sofern du nicht über die erforderlichen Rechte verfügst.",
        "Stelle sicher, dass regulierte Produkte und Dienstleistungen allen geltenden Gesetzen und Einschränkungen entsprechen.",
      ],
    },
  ],
},

contactAdsSupport: {
  title: "Werbesupport kontaktieren",
  body: [
    {
      type: "paragraph",
      text: "Kontaktiere den Support, wenn du ein Problem mit deiner Werbekampagne nicht selbst lösen kannst.",
    },
    {
      type: "bullets",
      items: [
        "Gib – falls vorhanden – den Kampagnennamen oder die Kampagnen-ID an.",
        "Beschreibe das Problem möglichst genau.",
        "Teile mit, seit wann das Problem besteht.",
        "Füge bei Bedarf Screenshots hinzu.",
      ],
    },
  ],
},
  },
   },
} as const;


export default advertisementGuide; 